<template>
  <div class="ui-content dashboard res-analisis-page res-analisis-page-cp3">
  <div class="user-data">
        <v-row>
          <v-col cols="12" sm="12" class="batch-health-sort">
         <div class="progress-stat-drop">
            <div class="show-drop-down with-border-drop-down">
                 <v-select class="fix-160"
                   v-model="selectedSubjects"
                   :items="subjects"
                   label="Select Subject"
                   solo
                  content-class="selectcust-multi"
                 ></v-select>
            </div>
            
            <div class="show-drop-down">
              <div class="field-data">
                <multi-select
                  allText="All Chapters"
                  :items="chapters"
                  label="Select Chapters"
                  :onChange="onChapterChange"
                  :selectedItemsList="selectedChapters"
                  content-class="selectcust-multi"
                ></multi-select>
              </div>
            </div>
          
            <div class="show-drop-down">
              <div class="field-data">
                <multi-select
                  allText="All Topics"
                  :items="topics"
                  label="Select Topics"
                  :onChange="onTopicChanged"
                  :selectedItemsList="selectedTopics"
                  content-class="selectcust-multi"
                  
                ></multi-select>
              </div>
            </div>
            </div>
          </v-col>
        </v-row>
      </div>
    <v-card class="mx-auto normal-card autohg ProgressBarSubcard user-data-cl">
      
      <div
        class="analysis-block result-card-section pie-charts"
        id="pie-charts"
      >
      
      <div :key="items.id" v-for="items in groupedCenters">
         <div id="chart" class="pie-tooltip-block" :key="index" v-for="(health, index) in items">
         <div  class="indicate-50 tooltip-batch-name">
              <v-tooltip bottom content-class="cust-new-tooltip-top open-top ">
              <template v-slot:activator="{ on }">
                <span
                  v-on="on"
                   depressed
                    :class="{
                    'text-transform-none': true,
                    'btn-center': true,
                    'btn-default': true,
                    
                  }"
                   
                  >{{health.center_name.substring(0,18) + '...'}}</span
                >
              </template>
              <div class="tooltip">{{health.center_name}} </div>
            </v-tooltip>
            </div>
             <div  class="indicate-50"> 
            <v-tooltip bottom content-class="cust-new-tooltip-top open-top">
              <template v-slot:activator="{ on }">
                <span
                  v-on="on"
                   depressed
                    :class="{
                    'text-transform-none': true,
                    'btn-center': true,
                    'btn-default': true,
                  }"
                   
                  >{{health.batch_name.substring(0,18) + '...'}}</span
                >
              </template>
              <div>{{health.batch_name}} </div>
            </v-tooltip>

            </div>

        <div>
          <apexchart
            type="pie"
            :options="{
				states: {
					hover: {
						filter: {
							type: 'none',
							}
						},
					},

              ...chartOptions,
              labels: ['Health', ''],
              title: {
                //text: health.center_name,
                margin: 20,
                align: 'center',
              },
              subtitle: {
                //text: health.batch_name,
                margin: 10,
                align: 'center',
              },
              colors: [getColor(health.health), '#d0ddd7'],
            }"
            :series="[health.health, 100 - Number(health.health)]"
          ></apexchart>
         
        
        </div>
      
      </div>
       <hr
          v-if="
            items
          "
          />

      </div>
     
        
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ProgressBar from "@/components/common/ProgressBar.vue";
import constants from "@/utils/constants.js";

export default {
  name: "BatchHealth",
  
  mounted() {
    this.checkSessionData();
  },
  components: {
    ProgressBar,
  },
  data() {
    return {
      dataTreeLevel: { subjects: 2, chapter: 3, topic: 4 },
      subjects: [],
      selectedSubjects: null,
      chapters: [],
      selectedChapters: [],
      topics: [],
      selectedTopics: [],
      batchHealths: [],
      groupedCenters: {},
      isLoadedFirstTime: false,
      isCenterFirstTime: true,
      isBatchFirstTime: true,
      isLoadingFirstTime: true,
      chartOptions: {
        chart: {
          type: "pie",
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
        },
        legend: {
          show: false,
          showForSingleSeries: false,
          showForNullSeries: false,
          showForZeroSeries: false,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
            },
          },
        ],
      },
	  teacherSubjectId:[],
	  firstTimeLoading: true,
    };
  },
  computed: {
        ...mapState("userStore", ["user"])
    },
  methods: {
    ...mapActions({
      getAllBatchWiseHealth: "resultStore/getAllBatchWiseHealth",
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
      getTeacherSubject: "userStore/getTeacherSubject",
    }),
    getColor(percentage) {
      let color = "";
      if (percentage > 65) {
        color = constants.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN;
      } else if (percentage > 19) {
        color = constants.STUDENT_HEALTH_PERCENTAGE_COLOR.ORANGE;
      } else {
        color = constants.STUDENT_HEALTH_PERCENTAGE_COLOR.RED;
      }
      return color;
    },
    updateRouteDetails(details) {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd.tabDetails[crd.selectedTab]) {
        switch (details.type) {
          case "centerIds":
            crd.tabDetails[crd.selectedTab].centerIds = details.data.centerIds;
            break;
          case "batchIds":
            crd.tabDetails[crd.selectedTab].batchIds = details.data.batchIds;
            break;
          default:
            break;
        }
      }
      this.setRouteDetails(crd);
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.selectedCenterId = crd.tabDetails[crd.selectedTab].centerIds; // load center ids from session
        this.selectedBatch = crd.tabDetails[crd.selectedTab].batchIds; // load batches in session
      }
      this.getSubjectsChaptersTopics(this.dataTreeLevel.subjects, []);
    //   this.getBatchWiseHealthList();
      
    },
    // onSubjectChanged(selectedSubjects) {
    //   console.log("ONSUB",selectedSubjects)
    //   this.selectedSubjects = selectedSubjects;
    // },
    onChapterChange(selectedChapters) {
      this.selectedChapters = selectedChapters;
    },
    onTopicChanged(selectedTopics) {
      this.selectedTopics = selectedTopics;
    },
    getSubjectsChaptersTopics(level, parentIds) {
      // level: 2 for subjects, 3: chapters, 4 for topics
      let reqData = {
        level: level,
        parent_ids:typeof parentIds != 'object' ? [parentIds]:parentIds,
      };
      switch (level) {
        case this.dataTreeLevel.subjects:
          this.subjects = [];
          this.selectedSubjects = null;
        case this.dataTreeLevel.chapter:
          this.chapters = [];
          this.selectedChapters = [];
        case this.dataTreeLevel.topic:
          this.topics = [];
          this.selectedTopics = [];
          break;
      }
      if (
        level === this.dataTreeLevel.subjects ||
        (level > this.dataTreeLevel.subjects && (parentIds.length || typeof parentIds == 'number'))
      ) {
        this.$root.showLoader = true;
        this.getDataTreeWithLevel(reqData)
          .then((response) => {
      this.getBatchWiseHealthList();

            // this.$root.showLoader = false;
            response = response.map((x) => {
              return { text: x.title, value: x.id };
            });
            switch (level) {
              case this.dataTreeLevel.subjects:
                this.subjects = response;
				if(this.user.role_id === this.roleIds.TR){
				this.getTeacherSubjectTree();
				}
                break;
              case this.dataTreeLevel.chapter:
                this.chapters = response;
                break;
              case this.dataTreeLevel.topic:
                this.topics = response;
                break;
            }
          })
          .catch((err) => {
            console.log(err);
            this.$toasted.error(
              `Error getting ${
                level === this.dataTreeLevel.subjects
                  ? "subjects"
                  : level === this.dataTreeLevel.chapter
                  ? "chapters"
                  : "topics"
              }`,
              { icon: "info" }
            );
            this.$root.showLoader = false;
          });
      }
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {
          default: { page: 1, centerIds: null, batchIds: null },
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: "default",
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
      // this.getTestList();
    },
    getColor(percentage) {
      let color = "";
      if (percentage > 65) {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN;
      } else if (percentage > 19) {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.ORANGE;
      } else {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.RED;
      }
      return color;
    },
    resetPage() {
      this.currentPage = 1;
      this.updateCurrentPageInSession(1);
    },
    getBatchWiseHealthList() {
      this.subjectWiseData = [];  
      let postData = {
        subject_ids: this.selectedSubjects?[this.selectedSubjects]:[],
        chapter_ids: this.selectedChapters,
        topic_ids: this.selectedTopics,
      };
      let me = this;
    //   if (this.$root.showLoader) {
        this.$root.showLoader = true;
        this.getAllBatchWiseHealth(postData)
          .then((response) => {
            this.$root.showLoader = false;
	  this.firstTimeLoading= false,

            this.batchHealths = response.list;
            let me = this;
            me.groupedCenters = _.mapValues(_.groupBy(this.batchHealths, 'center_name'),
              clist => clist.map(car => _.omit(car, 'batch_id')));
            this.$forceUpdate();
            // .concat(response.list.concat(response.list));
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
    //   }

    },
	getTeacherSubjectTree() {
      this.getTeacherSubject()
        .then((response) => {
          this.teacherSubjectId = response;
		  this.subjects = this.subjects.filter((res, i) =>
            this.teacherSubjectId.includes(res.value)
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    selectedSubjects(val) {
		if (!this.firstTimeLoading && val) {
      this.getSubjectsChaptersTopics(this.dataTreeLevel.chapter, val);
      //this.groupedCenters.length = 0;
    //   this.getBatchWiseHealthList();
	
		}    
		},
    selectedChapters(val) {
		if (!this.firstTimeLoading && val && val.length) {

      this.getSubjectsChaptersTopics(this.dataTreeLevel.topic, val);
      // this.groupedCenters.length = 0;
    //   this.getBatchWiseHealthList();
		}
    },
    selectedTopics(val) {
		if (!this.firstTimeLoading && val && val.length) {

      // this.groupedCenters.length = 0;
      this.getBatchWiseHealthList();
		}
    },
  },
};
</script>
